"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObject_1 = require("../AnimationObject");
var AssetType;
(function (AssetType) {
    AssetType[AssetType["Image"] = 2] = "Image";
    AssetType[AssetType["Precomp"] = 0] = "Precomp";
})(AssetType = exports.AssetType || (exports.AssetType = {}));
var Asset = (function (_super) {
    tslib_1.__extends(Asset, _super);
    function Asset(type, rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        _this.type = type;
        return _this;
    }
    Object.defineProperty(Asset.prototype, "id", {
        get: function () {
            return this._rawData.id;
        },
        set: function (id) {
            this._rawData.id = id;
        },
        enumerable: true,
        configurable: true
    });
    Asset.prototype.toJSON = function () {
        return {
            type: this.type,
            id: this.id,
        };
    };
    return Asset;
}(AnimationObject_1.AnimationObject));
exports.Asset = Asset;
//# sourceMappingURL=Asset.js.map